export var Urls = {
    GetStatusReasonTransitions: "StatusReasonTransitions/GetStatusReasonTransitions",
    GetAvailableStatusReasonTransitions: "StatusReasonTransitions/GetAvailableStatusReasonTransitions",
    SaveStatusReasonTransitions: "StatusReasonTransitions/SaveStatusReasonTransitions",
};
